export default __webpack_public_path__ + "static/media/485.4bf120b4.png";